<div class="qrc-container">
  <canvas #canvas></canvas>
  @if (source) {
    <img [src]="source" [title]="title" [alt]="title" />
  }
</div>
